
import { CatalogosProps } from "../interfaces/catalogos/CatalogosInterface";

export const catalogosList: CatalogosProps[] = [
    { id: '1', descripcion: 'Unidad', path: '/administracion/catalogos/unidad' },
    { id: '2', descripcion: 'Tipo de servicio', path: '/administracion/catalogos/tipoServicio' },
];